import styled from 'styled-components';

import { Button as DefaultButton } from '@xing-com/button';
import { PopUp as DefaultPopUp } from '@xing-com/crate-jobs-components-pop-up';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { Dropdown as DefaultDropdown } from '@xing-com/text-field';
import { spaceL, spaceM, spaceXL, spaceXXL } from '@xing-com/tokens';
import { BodyCopy as DefaultBodyCopy } from '@xing-com/typography';

export const PopUp = styled(DefaultPopUp)`
  height: 662px;
`;

export const LegalText = styled(DefaultBodyCopy)`
  margin-top: ${spaceXL};
`;

export const SaveAndContinueButton = styled(DefaultButton)`
  @media ${mediaSmallOrTiny} {
    width: 100%;
  }
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const MobileContent = styled.div`
  @media ${mediaSmallOrTiny} {
    box-sizing: border-box;
    display: flex;
    min-height: 100%;
    padding: ${spaceXL};
  }
`;

export const Headline = styled.h2`
  margin: 0 0 ${spaceXL};
`;

export const QuestionsContainer = styled.div`
  display: grid;
  gap: ${spaceXL};
`;

export const QuestionFieldset = styled.fieldset`
  border: 0;
  margin: 0;
  padding: 0;
`;

export const QuestionLegend = styled.legend`
  margin-bottom: ${spaceL};
  font-weight: bold;
`;

export const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  gap: ${spaceM};
`;

export const LanguageLevelDropdown = styled(DefaultDropdown)`
  width: 100%;
`;

export const Actions = styled.div`
  display: flex;
  gap: ${spaceM};
  justify-content: flex-end;
  margin-top: ${spaceXXL};

  @media ${mediaSmallOrTiny} {
    margin-top: auto;
    padding-top: ${spaceXXL};
  }
`;
